import classNames from 'classnames';
import React from 'react';
import {useShallow} from 'zustand/react/shallow';

import {LoadingSpinner, Text} from '@albert-io/atomic';
import StudentHomepageSidebarItem from './StudentHomepageSidebarItem';
import {useStudentDashboard} from 'client/Classrooms/StudentDashboard/StudentDashboard.store';

interface Props {
  isLoading: boolean;
}

export default function StudentHomepageSidebar({isLoading}: Props) {
  const {classrooms, setShowJoinClassModal} = useStudentDashboard(
    useShallow((state) => ({
      classrooms: state.classrooms,
      setShowJoinClassModal: state.setShowJoinClassModal
    }))
  );

  const currentTab = window.location.pathname.split('/').slice(-1)[0];

  return (
    <div className='row-span-2 flex flex-col gap-x3 self-stretch justify-self-stretch px-x4 py-x3'>
      <StudentHomepageSidebarItem
        className='mb-x3'
        icon='home'
        selected={!window.location.pathname.includes('/class')}
        to={`/home/${currentTab}`}
      >
        Home
      </StudentHomepageSidebarItem>
      <div
        className={classNames('flex-1', {
          'flex items-center justify-center': isLoading
        })}
      >
        {isLoading ? (
          <LoadingSpinner bottomMarginLevel={0} size={3} />
        ) : (
          <>
            <Text className='mb-x1-half ml-x2 block' color='secondary' size='s'>
              Classrooms
            </Text>
            {classrooms.size === 0 ? (
              <div className='mx-x2 rounded-x1 border border-dashed border-primary px-x2 py-x3 text-center'>
                <Text color='secondary'>Your classes will appear here</Text>
              </div>
            ) : (
              <>
                {classrooms.map((classroom) => (
                  <StudentHomepageSidebarItem
                    key={classroom.getId()}
                    selected={window.location.pathname.includes(classroom.getId())}
                    to={`/home/class/${classroom.getId()}/${currentTab}`}
                  >
                    {classroom.getName()}
                  </StudentHomepageSidebarItem>
                ))}
                <StudentHomepageSidebarItem
                  className='mt-x1-half content-brand!'
                  icon='plus'
                  onClick={() => {
                    setShowJoinClassModal(true);
                  }}
                >
                  Join Class
                </StudentHomepageSidebarItem>
              </>
            )}
          </>
        )}
      </div>
      <StudentHomepageSidebarItem icon='chart-line' to='/my-data'>
        My Data
      </StudentHomepageSidebarItem>
    </div>
  );
}
